import { ChevronDown, Download, Search, Star, X } from "lucide-react";
import { useCategoryCounts } from "@/hooks/queries";

const Select = ({ value, onChange, children, testid, className = "" }) => (
  <span className={`relative ${className}`}>
    <select className="t-input h-11 pr-10 text-[14px] font-medium bg-white appearance-none cursor-pointer" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}>{children}</select>
    <ChevronDown className="absolute right-3 top-3 w-5 h-5 text-[#64748B] pointer-events-none" />
  </span>
);

export default function ContactsDesktopToolbar({ total, search, setSearch, categoryId, setCat, favorite, setFavorite, sort, setSort, sorts, onExport }) {
  const counts = useCategoryCounts().data;
  const cats = (counts?.categories ?? []).filter((c) => c.count > 0 || c.id === categoryId);
  const active = cats.find((c) => c.id === categoryId);
  return (
    <div className="hidden lg:block" data-testid="contacts-desktop-toolbar">
      <div className="flex items-end justify-between">
        <div>
          <h1 className="text-[32px] font-extrabold leading-tight">Contacts</h1>
          <p className="text-[14px] text-[#64748B]" data-testid="contacts-total">{total} contact{total === 1 ? "" : "s"}{active ? ` in ${active.name}` : ""}{favorite ? " · favorites" : ""}</p>
        </div>
        <button className="t-btn t-btn-outline h-11 text-[14px] px-4" onClick={onExport} data-testid="contacts-export-desktop"><Download className="w-4 h-4" />Export CSV</button>
      </div>
      <div className="t-card mt-5 p-3 flex items-center gap-3">
        <span className="relative flex-1 max-w-md">
          <Search className="absolute left-3.5 top-3 w-5 h-5 text-[#64748B]" />
          <input className="t-input h-11 pl-11 text-[14px] bg-white" placeholder="Search name, company, phone, email" value={search} onChange={(e) => setSearch(e.target.value)} data-testid="contacts-search-desktop" />
        </span>
        <Select value={categoryId ?? ""} onChange={(v) => setCat(v || null)} testid="contacts-category-select" className="w-60">
          <option value="">All categories ({counts?.total ?? total})</option>
          {cats.map((c) => <option key={c.id} value={c.id}>{c.name} ({c.count})</option>)}
        </Select>
        <Select value={sort} onChange={setSort} testid="contacts-sort-select" className="w-44">
          {sorts.map((s) => <option key={s.key} value={s.key}>{s.label}</option>)}
        </Select>
        <button onClick={() => setFavorite(!favorite)} data-testid="contacts-favorite-desktop"
          className={`h-11 px-4 rounded-[14px] border text-[14px] font-semibold inline-flex items-center gap-2 transition-colors ${favorite ? "bg-[#FEF9C3] border-[#FDE68A] text-[#B45309]" : "border-[#DFE5F0] text-[#334155] hover:bg-[#F8FAFC]"}`}>
          <Star className={`w-4 h-4 ${favorite ? "fill-[#D97706] text-[#D97706]" : ""}`} />Favorites
        </button>
        {(search || categoryId || favorite) && (
          <button className="ml-auto t-link inline-flex items-center gap-1" onClick={() => { setSearch(""); setCat(null); setFavorite(false); }} data-testid="contacts-clear-filters"><X className="w-4 h-4" />Clear</button>
        )}
      </div>
    </div>
  );
}
